export const options = [
  { value: "full-stack-developer", label: "Full-stack Developer" },
  { value: "front-end-developer", label: "Front-end Developer" },
  { value: "back-end-developer", label: "Back-end Developer" },
  { value: "business-analyst", label: "Business Analyst" },
  { value: "ux-ui-designer", label: "UI/UX Designer" },
  { value: "software-tester", label: "Software Tester/QA Engineer" },
  { value: "qa-lead", label: "QA Lead/ Test Manager" },
  { value: "project-manager", label: "Project Manager" },
  { value: "enterprise-architect", label: "Enterprise Architect" },
  { value: "software-architect", label: "Software Architect" },
  { value: "scrum-master", label: "Scrum Master" },
  { value: "devops-engineer", label: "DevOps Engineer" },
  { value: "team-lead", label: "Team Lead/ Tech Lead" },
  { value: "dba-db-developer", label: "DBA/DB Developer" },
  { value: "other", label: "Other" },
];

export const languages = [
  {
    value: "python",
    name: "Python",
  },
  {
    value: "javascript",
    name: "JavaScript",
  },
  {
    value: "html",
    name: "HTML",
  },
  {
    value: "css",
    name: "CSS",
  },
  {
    value: "java",
    name: "Java",
  },
  {
    value: "swift",
    name: "Swift",
  },
  {
    value: "c++",
    name: "C++",
  },
  {
    value: "c#",
    name: "C#",
  },
  {
    value: "r",
    name: "R",
  },
  {
    value: "golang",
    name: "Golang (Go)",
  },
  {
    value: "php",
    name: "PHP",
  },
  {
    value: "typeScript",
    name: "TypeScript",
  },

  {
    value: "scala",
    name: "Scala",
  },

  {
    value: "shell",
    name: "Shell",
  },

  {
    value: "powershell",
    name: "PowerShell",
  },
  {
    value: "scala",
    name: "Scala",
  },

  {
    value: "perl",
    name: "Perl",
  },

  {
    value: "haskell",
    name: "Haskell",
  },
  {
    value: "kotlin",
    name: "Kotlin",
  },
  {
    value: "visualbasic",
    name: "Visual Basic .NET",
  },
  {
    value: "sql",
    name: "SQL",
  },
  {
    value: "delphi",
    name: "Delphi",
  },
  {
    value: "groovy",
    name: "Groovy",
  },
  {
    value: "lua",
    name: "Lua",
  },
  {
    value: "rust",
    name: "Rust",
  },
  {
    value: "ruby",
    name: "Ruby",
  },
  {
    value: "c",
    name: "C",
  },
  {
    value: "dart",
    name: "Dart",
  },
  {
    value: "matlab",
    name: "Matlab",
  },
  {
    value: "nosql",
    name: "NoSQL",
  },
  {
    value: "julia",
    name: "Julia",
  },
  {
    value: "fortran",
    name: "Fortran",
  },
  {
    value: "cobal",
    name: "COBOL",
  },
  {
    value: "lisp",
    name: "Lisp",
  },
  {
    value: "foxpro",
    name: "(Visual) FoxPro",
  },
  {
    value: "ada",
    name: "Ada",
  },
  {
    value: "prolog",
    name: "Prolog",
  },
  {
    value: "plsql",
    name: "PL/SQL",
  },
  {
    value: "bash",
    name: "Bash",
  },
];

export const levels = [
  {
    value: 1,
    name: "Beginner",
  },
  {
    value: 2,
    name: "Advanced Beginner",
  },
  {
    value: 3,
    name: "Intermediate",
  },
  {
    value: 4,
    name: "Advanced",
  },
  {
    value: 5,
    name: "Expert",
  },
];

export const levelValue = [
  {
    value: 1,
    name: "Beginner",
  },
  {
    value: 2,
    name: "Advanced Beginner",
  },
  {
    value: 3,
    name: "Intermediate",
  },
  {
    value: 4,
    name: "Advanced",
  },
  {
    value: 5,
    name: "Expert",
  },
];

//This class contains the array lists

export const languagesNames = [
  { value: "English", label: "English" },
  { value: "French", label: "French" },
  { value: "Spanish", label: "Spanish" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "German", label: "German" },
  { value: "Italian", label: "Italian" },
  { value: "Swedish", label: "Swedish" },
  // { value: "Other", label: "Other" }
];

export const monthNames = [
  { value: 1, name: "January" },
  { value: 2, name: "February" },
  { value: 3, name: "March" },
  { value: 4, name: "April" },
  { value: 5, name: "May" },
  { value: 6, name: "June" },
  { value: 7, name: "July" },
  { value: 8, name: "August" },
  { value: 9, name: "September" },
  { value: 10, name: "October" },
  { value: 11, name: "November" },
  { value: 12, name: "December" },
];

export const methodologyNames = ["Agile", "Scrum", "Kanban"];

export const methodLevels = [
  "Novice",
  "Beginner",
  "Intermediate",
  "Advanced",
  "Expert",
];

export const contractualStatusOptions = [
  "candidate",
  "intern",
  "subconsultant",
  "employee",
  "alumni/inactive",
];

export const seniorityLevels = [
  "Entry Level (0-1 years)",
  "Junior level (1-2 years)",
  "Mid Level (3-5 years)",
  "Senior level (6+ years)",
];

export const primaryRoles = [
  "Software Developer",
  "Full-stack Developer",
  "Front-end Developer",
  "Back-end Developer",
  "Business Analyst",
  "UX / UI Designer",
  "Software Tester / QA Engineer",
  "QA Lead / Test Manager",
  "Project Manager",
  "Enterprise Architect",
  "Software Architect",
  "Scrum Master",
  "Team Lead / Tech Lead",
  "Other",
];

export const operatingSystemNames = [
  "RHEL Linux",
  "Fedora Linux",
  "CentOs Linux",
  "Debian Linux",
  "SLES Linux",
  "SuSe Linux",
  "Ubuntu Linux",
  "MS Windows XP/7/8/10",
  "MS Windows Server 2008/2012/2016/2019",
  "MacOS",
  "IBM",
  "Aix",
  "Unix",
  "HP-UX",
  "Unix OS/2",
];

export const databaseNames = [
  "Oracle RDBMS",
  "Oracle DB BM DB2",
  "Microsoft SQL Server",
  "Sybase",
  "ASE",
  "SAP",
  "HANA",
  "Teradata",
  "ADABAS",
  "MySQL",
  "FileMaker",
  "Informix",
  "SQLite",
  "PostgreSQL",
  "Amazon RDS",
  "MongoDB",
  "Redis",
  "CouchDB",
  "Neo4j",
  "OrientDB",
  "Couchbase",
  "Toad",
  "Hadoop",
  "HDFS",
  "MariaDB",
  "Informix",
  "Dynamic Servers",
  "RDM Server",
];

export const integrationNames = [
  "API",
  "COBRA",
  "Data",
  "Power",
  "DCOM",
  "ESB",
  "EJB",
  "IDL",
  "JMS",
  "MQ",
  "OLE",
  "RestAPI",
  "RMI",
  "SOAP",
  "Web Services",
  "XML",
];

export const frameworkNames = [
  "Alpine.js",
  "Angular",
  "ASP.NET",
  "Backbone.js",
  "Blade",
  "Django",
  "Dropwizard",
  "Eleventy",
  "Elixir",
  "Ember.js",
  "Express",
  "Expo",
  "Fiber",
  "Flask",
  "Flutter",
  "Gatsby",
  "Hugo",
  "Ionic",
  "Jekyll",
  "KeystoneJS",
  "Koa",
  "Laravel",
  "Lit",
  "Meteor",
  "NativeScript",
  "NestJS",
  "Next.js",
  "Node.js",
  "Nuxt.js",
  "Play",
  "Preact",
  "Quasar",
  "Rails",
  "React",
  "React Native",
  "RedwoodJS",
  "Remix",
  "Sails.js",
  "Sanity",
  "SolidJS",
  "Spring",
  "Stimulus",
  "Strapi",
  "Struts",
  "Svelte",
  "Vaadin",
  "VueJS"
];

export const careerBreakType = [
  "Bereavement",
  "Career transition",
  "Caregiving",
  "Fulltime-time parenting",
  "Gap year",
  "Layoff/position eliminated",
  "Health and well-being",
  "Personal goal pursuit",
  "Professional development",
  "Relocation",
  "Travel",
  "Voluntary work",
];

export const roleInProject = [
  { value: "Product Owner", label: "Product Owner" },
  { value: "API Developer", label: "API Developer" },
  { value: "DBA Developer", label: "DBA Developer" },
  { value: "DevOps Engineer", label: "DevOps Engineer" },
  { value: "AI Developer", label: "AI Developer" },
  { value: "ML Expert", label: "ML Expert" },
  { value: "Data Scientist", label: "Data Scientist" },
  { value: "Software Developer", label: "Software Developer" },
  { value: "Full-stack Developer", label: "Full-stack Developer" },
  { value: "Front-end Developer", label: "Front-end Developer" },
  { value: "Back-end Developer", label: "Back-end Developer" },
  { value: "Business Analyst", label: "Business Analyst" },
  { value: "UX / UI Designer", label: "UX / UI Designer" },
  {
    value: "Software Tester / QA Engineer",
    label: "Software Tester / QA Engineer",
  },
  { value: "QA Lead / Test Manager", label: "QA Lead / Test Manager" },
  { value: "Project Manager", label: "Project Manager" },
  { value: "Enterprise Architect", label: "Enterprise Architect" },
  { value: "Software Architect", label: "Software Architect" },
  { value: "Scrum Master", label: "Product Owner" },
  { value: "Team Lead / Tech Lead", label: "Team Lead / Tech Lead" },
  { value: "Other", label: "Other" },
];

export const qaSkills = [
  {
    value: "api testing",
    name: "API testing",
  },
  {
    value: "unit testing",
    name: "Unit testing",
  },
  {
    value: "e2e testing",
    name: "E2E testing",
  },
  {
    value: "security testing/penetration tests",
    name: "Security testing/Penetration tests",
  },
  {
    value: "load testing",
    name: "Load testing",
  },
  {
    value: "test automation",
    name: "Test automation",
  },
  {
    value: "writing Test plans++",
    name: "Writing Test plans++",
  },
  {
    value: "writing Test cases",
    name: "writing test cases",
  },
  {
    value: "writing defect reports",
    name: "Writing defect reports",
  },
  {
    value: "knowledge of the testing process",
    name: "Knowledge of the testing process",
  },
  {
    value: "regression testing",
    name: "Regression testing",
  },
];

export const areasOfExpertise = [
  {
    value: "leading development teams",
    label: "Leading development teams",
  },
  {
    value: "solution design",
    label: "Solution design",
  },
  {
    value: "artificial intelligence",
    label: "Artificial intelligence",
  },
  {
    value: "cloud Computing",
    label: "Cloud Computing",
  },
  {
    value: "cybersecurity",
    label: "Cybersecurity",
  },
  {
    value: "information security",
    label: "Information security",
  },
  {
    value: "machine learning",
    label: "Machine learning",
  },
  {
    value: "data science",
    label: "Data science",
  },
  {
    value: "automation",
    label: "Automation",
  },
  {
    value: "development (applications and software)",
    label: "Development (applications and software)",
  },
  {
    value: "ux/ui Design",
    label: "UX/UI Design",
  },
  {
    value: "product Management",
    label: "Product Management",
  },
  {
    value: "api & integration management",
    label: "API & Integration Management",
  },
  {
    value: "software architecture",
    label: "Software architecture",
  },
  {
    value: "qa & testing",
    label: "QA & Testing",
  },
  {
    value: "iam (identity access management)",
    label: "IAM (Identity Access Management)",
  },
  {
    value: "cryptography",
    label: "Cryptography",
  },

  {
    value: "microservices",
    label: "Microservices",
  },
  {
    value: "bootstrapping",
    label: "Bootstrapping",
  },
  {
    value: "container technologies",
    label: "Container Technologies",
  },
  {
    value: "agile work methods",
    label: "Agile work methods",
  },
  {
    value: "infrastructure",
    label: "Infrastructure",
  },
  {
    value: "cms systems",
    label: "CMS Systems",
  },
  {
    value: "erp systems",
    label: "ERP systems",
  },
  {
    value: "crm systems",
    label: "CRM systems",
  },
  {
    value: "database design",
    label: "Database design",
  },
  {
    value: "Devops",
    label: "devops",
  },
  {
    value: "configuration management",
    label: "Configuration Management",
  },
  {
    value: "web development",
    label: "Web development",
  },
  {
    value: "mobile development",
    label: "Mobile development",
  },
  {
    value: "payments",
    label: "Payments",
  },
  {
    value: "continuous delivery",
    label: "Continuous Delivery",
  },
  {
    value: "data migration",
    label: "Data migration",
  },
  {
    value: "mobile app design",
    label: "Mobile app design",
  },
  {
    value: "scrum master",
    label: "Database design",
  },
  // Frontend & mobile
  {
    value: "React",
    label: "React",
  },
  {
    value: "Angular",
    label: "Angular",
  },
  {
    value: "Vue.js",
    label: "Vue.js",
  },
  {
    value: "Next.js",
    label: "Next.js",
  },
  {
    value: "Svelte",
    label: "Svelte",
  },
  {
    value: "TypeScript",
    label: "TypeScript",
  },
  {
    value: "JavaScript",
    label: "JavaScript",
  },
  {
    value: "HTML",
    label: "HTML",
  },
  {
    value: "CSS",
    label: "CSS",
  },
  {
    value: "Redux",
    label: "Redux",
  },
  {
    value: "Tailwind CSS",
    label: "Tailwind CSS",
  },
  {
    value: "React Native",
    label: "React Native",
  },
  {
    value: "Flutter",
    label: "Flutter",
  },
  {
    value: "Swift",
    label: "Swift",
  },
  {
    value: "Kotlin",
    label: "Kotlin",
  },
  {
    value: "iOS development",
    label: "iOS development",
  },
  {
    value: "Android development",
    label: "Android development",
  },
  // Backend & languages
  {
    value: "Node.js",
    label: "Node.js",
  },
  {
    value: "Express.js",
    label: "Express.js",
  },
  {
    value: "Python",
    label: "Python",
  },
  {
    value: "Django",
    label: "Django",
  },
  {
    value: "FastAPI",
    label: "FastAPI",
  },
  {
    value: "Java",
    label: "Java",
  },
  {
    value: "Spring Boot",
    label: "Spring Boot",
  },
  {
    value: "C#",
    label: "C#",
  },
  {
    value: ".NET",
    label: ".NET",
  },
  {
    value: "Go",
    label: "Go",
  },
  {
    value: "PHP",
    label: "PHP",
  },
  {
    value: "Laravel",
    label: "Laravel",
  },
  {
    value: "Ruby on Rails",
    label: "Ruby on Rails",
  },
  {
    value: "Rust",
    label: "Rust",
  },
  {
    value: "C++",
    label: "C++",
  },
  {
    value: "GraphQL",
    label: "GraphQL",
  },
  {
    value: "REST APIs",
    label: "REST APIs",
  },
  {
    value: "gRPC",
    label: "gRPC",
  },
  {
    value: "Kafka",
    label: "Kafka",
  },
  {
    value: "RabbitMQ",
    label: "RabbitMQ",
  },
  {
    value: "Event-driven architecture",
    label: "Event-driven architecture",
  },
  // Data & databases
  {
    value: "SQL",
    label: "SQL",
  },
  {
    value: "PostgreSQL",
    label: "PostgreSQL",
  },
  {
    value: "MySQL",
    label: "MySQL",
  },
  {
    value: "Microsoft SQL Server",
    label: "Microsoft SQL Server",
  },
  {
    value: "Oracle Database",
    label: "Oracle Database",
  },
  {
    value: "MongoDB",
    label: "MongoDB",
  },
  {
    value: "Redis",
    label: "Redis",
  },
  {
    value: "Elasticsearch",
    label: "Elasticsearch",
  },
  {
    value: "Data engineering",
    label: "Data engineering",
  },
  {
    value: "ETL",
    label: "ETL",
  },
  {
    value: "Apache Spark",
    label: "Apache Spark",
  },
  {
    value: "Databricks",
    label: "Databricks",
  },
  {
    value: "Snowflake",
    label: "Snowflake",
  },
  {
    value: "dbt",
    label: "dbt",
  },
  {
    value: "Apache Airflow",
    label: "Apache Airflow",
  },
  {
    value: "Data warehousing",
    label: "Data warehousing",
  },
  {
    value: "Data analysis",
    label: "Data analysis",
  },
  {
    value: "Data visualization",
    label: "Data visualization",
  },
  {
    value: "Power BI",
    label: "Power BI",
  },
  {
    value: "Tableau",
    label: "Tableau",
  },
  // AI & ML
  {
    value: "Deep learning",
    label: "Deep learning",
  },
  {
    value: "Natural language processing",
    label: "Natural language processing",
  },
  {
    value: "Computer vision",
    label: "Computer vision",
  },
  {
    value: "Large language models",
    label: "Large language models",
  },
  {
    value: "MLOps",
    label: "MLOps",
  },
  {
    value: "TensorFlow",
    label: "TensorFlow",
  },
  {
    value: "PyTorch",
    label: "PyTorch",
  },
  {
    value: "scikit-learn",
    label: "scikit-learn",
  },
  // Cloud & DevOps
  {
    value: "AWS",
    label: "AWS",
  },
  {
    value: "Azure",
    label: "Azure",
  },
  {
    value: "GCP",
    label: "GCP",
  },
  {
    value: "Docker",
    label: "Docker",
  },
  {
    value: "Kubernetes",
    label: "Kubernetes",
  },
  {
    value: "Helm",
    label: "Helm",
  },
  {
    value: "Terraform",
    label: "Terraform",
  },
  {
    value: "Ansible",
    label: "Ansible",
  },
  {
    value: "Infrastructure as Code",
    label: "Infrastructure as Code",
  },
  {
    value: "CI/CD",
    label: "CI/CD",
  },
  {
    value: "GitHub Actions",
    label: "GitHub Actions",
  },
  {
    value: "GitLab CI",
    label: "GitLab CI",
  },
  {
    value: "Jenkins",
    label: "Jenkins",
  },
  {
    value: "Azure DevOps",
    label: "Azure DevOps",
  },
  {
    value: "Git",
    label: "Git",
  },
  {
    value: "Linux",
    label: "Linux",
  },
  {
    value: "Serverless",
    label: "Serverless",
  },
  {
    value: "Site reliability engineering",
    label: "Site reliability engineering",
  },
  {
    value: "Observability",
    label: "Observability",
  },
  {
    value: "Prometheus",
    label: "Prometheus",
  },
  {
    value: "Grafana",
    label: "Grafana",
  },
  // QA & testing
  {
    value: "Test automation",
    label: "Test automation",
  },
  {
    value: "Manual testing",
    label: "Manual testing",
  },
  {
    value: "Performance testing",
    label: "Performance testing",
  },
  {
    value: "Accessibility testing",
    label: "Accessibility testing",
  },
  {
    value: "Selenium",
    label: "Selenium",
  },
  {
    value: "Cypress",
    label: "Cypress",
  },
  {
    value: "Playwright",
    label: "Playwright",
  },
  {
    value: "Jest",
    label: "Jest",
  },
  {
    value: "JUnit",
    label: "JUnit",
  },
  {
    value: "pytest",
    label: "pytest",
  },
  {
    value: "Appium",
    label: "Appium",
  },
  {
    value: "Postman",
    label: "Postman",
  },
  {
    value: "JMeter",
    label: "JMeter",
  },
  {
    value: "Cucumber",
    label: "Cucumber",
  },
  // Security
  {
    value: "Penetration testing",
    label: "Penetration testing",
  },
  {
    value: "OWASP",
    label: "OWASP",
  },
  {
    value: "DevSecOps",
    label: "DevSecOps",
  },
  {
    value: "Network security",
    label: "Network security",
  },
  {
    value: "GDPR compliance",
    label: "GDPR compliance",
  },
  // Design
  {
    value: "Figma",
    label: "Figma",
  },
  {
    value: "User research",
    label: "User research",
  },
  {
    value: "Interaction design",
    label: "Interaction design",
  },
  {
    value: "Prototyping",
    label: "Prototyping",
  },
  {
    value: "Design systems",
    label: "Design systems",
  },
  {
    value: "Service design",
    label: "Service design",
  },
  // Delivery & business systems
  {
    value: "Jira",
    label: "Jira",
  },
  {
    value: "Confluence",
    label: "Confluence",
  },
  {
    value: "SAFe",
    label: "SAFe",
  },
  {
    value: "ITIL",
    label: "ITIL",
  },
  {
    value: "PRINCE2",
    label: "PRINCE2",
  },
  {
    value: "Project management",
    label: "Project management",
  },
  {
    value: "Business analysis",
    label: "Business analysis",
  },
  {
    value: "Requirements analysis",
    label: "Requirements analysis",
  },
  {
    value: "Agile coaching",
    label: "Agile coaching",
  },
  {
    value: "Release management",
    label: "Release management",
  },
  {
    value: "SAP",
    label: "SAP",
  },
  {
    value: "Salesforce",
    label: "Salesforce",
  },
  {
    value: "Microsoft Dynamics 365",
    label: "Microsoft Dynamics 365",
  },
  {
    value: "ServiceNow",
    label: "ServiceNow",
  },
  {
    value: "SharePoint",
    label: "SharePoint",
  },
  {
    value: "Power Platform",
    label: "Power Platform",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const DEGREE_OPTIONS = [
  "High School Diploma",
  "Associate's Degree",
  "Bachelor's Degree",
  "Postgraduate Diploma",
  "Master's Degree",
  "MBA",
  "Doctoral Degree (PhD)",
  "Professional Degree (MD / JD / etc.)",
  "Vocational / Trade Certificate",
  "Other",
];

export const AI_LEVELS = ["Basic", "Intermediate", "Advanced", "Expert"];

export const AI_ENGINEERING_CATEGORIES = [
  {
    key: "foundationModels",
    label: "A. Foundation Models & LLMs",
    description: "Experience working with large language models and model providers.",
  },
  {
    key: "aiDevelopment",
    label: "B. AI Development & Architecture",
    description: "Designing AI-driven systems and solutions.",
  },
  {
    key: "mlAiEngineering",
    label: "C. ML/AI Engineering",
    description: "Integration and operationalization of AI systems.",
  },
  {
    key: "aiFrameworks",
    label: "D. AI Frameworks & Tooling",
    description: "Experience with AI development frameworks and tools.",
  },
  {
    key: "cloudAiPlatforms",
    label: "E. Cloud & AI Platforms",
    description: "Cloud-based AI services and deployment.",
  },
  {
    key: "agenticSystems",
    label: "F. Agentic Systems & Orchestration",
    description: "Experience designing and running multi-agent systems or autonomous workflows.",
  },
];

export const AI_ENABLED_WORK_CATEGORIES = [
  {
    key: "problemSolving",
    label: "A. AI-Assisted Problem Solving",
    description: "Using AI for analysis, research, ideation, and decision support.",
  },
  {
    key: "productivityTools",
    label: "B. AI in Productivity Tools",
    description: "Experience with AI-powered productivity and collaboration tools.",
  },
  {
    key: "deliveryWorkflows",
    label: "C. AI in Delivery Workflows",
    description: "Using AI in project delivery and development processes.",
  },
  {
    key: "communication",
    label: "D. AI-Supported Communication",
    description: "Using AI to enhance communication and documentation.",
  },
];
